import type {
    UserServiceCreationParams,
    UserServiceData,
    UserServiceListQuery,
    UserServiceListResponse,
    UserServiceUpdateParams,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/user-service';

export class UserServiceApi {
    public static async list(params?: UserServiceListQuery): Promise<UserServiceData[]> {
        const res = await axios.get<UserServiceListResponse>(BASE_URL, { params });

        return res.data.userServices;
    }

    public static async create(userService: UserServiceCreationParams): Promise<void> {
        await axios.post(BASE_URL, { userService });
    }

    public static async update(userServiceId: string, userService: UserServiceUpdateParams): Promise<void> {
        await axios.put(`${BASE_URL}/${userServiceId}`, { userService });
    }

    public static async delete(userServiceId: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${userServiceId}`);
    }
}
